(() => {
  const root = document.documentElement;
  const keyboardClass = "boost-keyboard-nav";

  root.classList.add("boost-focus-modality-ready");

  document.addEventListener("keydown", (event) => {
    if (event.key === "Tab") root.classList.add(keyboardClass);
  }, true);

  const usePointerMode = () => root.classList.remove(keyboardClass);
  document.addEventListener("pointerdown", usePointerMode, true);
  document.addEventListener("touchstart", usePointerMode, true);
  window.addEventListener("pageshow", usePointerMode);
})();
